import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { helper } from 'src/environments/helper';
import { CerereStatusService } from '../../../settings-sidenav/cerere-status/cerere-status.service';
import { UpdateMassStatusPayload } from '../request.interface';
import { RequestsService } from '../requests.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-update-request-status',
  templateUrl: './update-request-status.component.html',
  styleUrls: ['./update-request-status.component.scss'],
})
export class UpdateRequestStatusComponent implements OnInit {
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  isLoading = false;

  defaultParameter: { name: string; id: string } = {
    name: 'Toate',
    id: '-1',
  };

  requestStatuses$!: Observable<Generic[]>;

  form: FormGroup = new FormGroup({
    current_status: new FormControl('', [Validators.required]),
    message: new FormControl(''),
  });
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: number[],
    private dialogRef: MatDialogRef<UpdateRequestStatusComponent>,
    private cerereStatusService: CerereStatusService,
    private requestsService: RequestsService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadRequestStatuses();
  }

  loadRequestStatuses() {
    this.isLoading = true;
    this.requestStatuses$ = this.cerereStatusService.getStatuses().pipe(
      map((results: any) => [...results, this.defaultParameter]),
      finalize(() => (this.isLoading = false))
    );
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  submitForm() {
    this.isLoading = true;
    const ids_cerere = this.data;
    const currentStatusValue = this.form.get('current_status')?.value;
    const messageValue = this.form.get('mesaj')?.value;

    const newStatus: UpdateMassStatusPayload = {
      ids_cerere,
      current_status: currentStatusValue,
      message: messageValue,
    };

    this.requestsService
      .updateMassStatus(newStatus)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
